import { ApiMessage } from '@/api/api'

export default {
    data() {
        return {
            pollingHistoryMessageInterval: null
        }
    },
    created() {
        if (this.$store.state.active_chat_id) {
            this.pollingHistoryMessageInterval = setInterval(() => {
                this.pollingHistoryMessageLoad()
            }, 5000)
        }
        this.$store.watch(
            state => state.active_chat_id,
            newValue => {
                if (newValue) {
                    this.pollingHistoryMessageInterval = setInterval(() => {
                        this.pollingHistoryMessageLoad()
                    }, 5000)
                } else {
                    clearTimeout(this.pollingHistoryMessageInterval)
                }
            }
        )
    },
    beforeDestroy() {
        clearTimeout(this.pollingHistoryMessageInterval)
    },
    computed: {},
    methods: {
        pollingHistoryMessageLoad(id) {
            ApiMessage.history({
                polling: 1,
                offset: 0,
                limit: 10
            }).then(({ data: response }) => {
                if (!response.length) return

                response.forEach(item => {
                    item.time = parseInt(item.time)
                    item.id = parseInt(item.id)
                })

                response.sort((a, b) => b.id - a.id) // b - a for reverse sort

                response.reverse().forEach(val => {
                    let findIndex = this.$store.state.chat.messages.findIndex(
                        item => item.id === val.id
                    )

                    if (findIndex === -1) {
                        this.$root.$emit('emitSocketGetMessage', val)
                    } else {
                        let checkBody = this.$store.state.chat.messages.findIndex(
                            item => item.id === val.id && item.body !== val.body
                        )
                        if (checkBody !== -1) {
                            this.$store.state.chat.messages[findIndex].body = val.body
                        }
                    }
                })

                // response = response
                //     .reverse()
                //     .filter(
                //         message =>
                //             !this.$store.state.chat.messages.some(item => item.id === message.id)
                //     ) //убираем дубликаты
                //
                // this.$store.commit('chat/messagesuUnshift', response)
            })
        }
    }
}
